import './MessageTemplateSampleModalScss.scss';
import { CallToActionTypes } from '../models/MessageTemplateButtons';
export class MessageTemplateSampleModalController {
    static $inject = ['modal', 'MessageTemplateUtil', 'ModalService'];
    constructor(modal, MessageTemplateUtil, ModalService) {
        this.variables = [];
        this.headerVariables = [];
        this.buttonsVariables = [];
        this.isValidForm = false;
        this.variablesForm = [];
        this.headerVariablesForm = [];
        this.cardVariablesForm = [];
        this.cardButtonVariablesForm = [];
        this.bodyOriginal = '';
        this.headerOriginal = '';
        this.variablesButtonsForm = [];
        this.cardsOriginalText = [];
        this.onVariableChange = event => {
            const variable = this.getVariable(event.srcElement.id);
            this.setVariable(variable, event.detail.value);
            this.updateBody();
            this.isValid();
        };
        this.onHeaderVariableChange = event => {
            const variable = this.getHeaderVariable(event.srcElement.id);
            this.setHeaderVariable(variable, event.detail.value);
            this.updateHeader();
            this.isValid();
        };
        this.onButtonVariableChange = event => {
            const { buttonIndex, variableIndex } = this.parseButtonVariableId(event.srcElement.id);
            if (buttonIndex !== null &&
                variableIndex !== null &&
                this.buttonsVariables[buttonIndex]) {
                this.setButtonVariable(buttonIndex, variableIndex, event.detail.value);
            }
            this.isValid();
        };
        this.onTabChange = async (event) => {
            if (event?.detail?.id !== undefined) {
                const cardIndex = event.detail.id;
                const originalCard = this.modal.cards[cardIndex];
                const originalText = this.cardsOriginalText[cardIndex] || originalCard?.text || '';
                let cardTextChange = originalText;
                if (this.cardVariablesForm[cardIndex]) {
                    this.cardVariablesForm[cardIndex].forEach((value, index) => {
                        const variable = `{{${index + 1}}}`;
                        if (value !== '' && value !== variable) {
                            cardTextChange = cardTextChange.replace(variable, value);
                        }
                    });
                }
                const formattedText = this.MessageTemplateUtil.formatMessageToPreviewView(cardTextChange);
                this.modal.previewCard = {
                    ...originalCard,
                    text: formattedText,
                };
            }
        };
        this.onCardVariableChange = event => {
            const idPattern = /{{(\d+)}}-card-(\d+)/;
            const match = event.srcElement.id.match(idPattern);
            if (match) {
                const variableIndex = parseInt(match[1], 10) - 1; // variavel x está na posição x-1
                const cardIndex = parseInt(match[2], 10); // tab/card correspondente
                this.setCardVariable(cardIndex, variableIndex, event.detail.value);
                this.updateCard(cardIndex);
                this.isValid();
            }
        };
        this.onCardButtonVariableChange = event => {
            const idPattern = /{{(\d+)}}-button-(\d+)-card-(\d+)/;
            const match = event.srcElement.id.match(idPattern);
            if (match) {
                const variableIndex = parseInt(match[1], 10) - 1;
                const buttonIndex = parseInt(match[2], 10);
                const cardIndex = parseInt(match[3], 10);
                this.setCardButtonVariable(cardIndex, buttonIndex, variableIndex, event.detail.value);
                this.isValid();
            }
        };
        this.isValid = () => {
            const variablesValid = this.variables?.length === 0 ||
                this.variables?.filter(variable => variable.value !== '' &&
                    variable.value !== variable.variable).length === this.variables?.length;
            const headerVariablesValid = this.headerVariables?.length === 0 ||
                this.headerVariables?.filter(variable => variable.value !== '' &&
                    variable.value !== variable.variable).length === this.headerVariables?.length;
            const buttonVariablesValid = this.buttonsVariables.every(button => {
                return button.values.every(val => val !== '' &&
                    val !== button.variables[button.values.indexOf(val)]);
            });
            const cardVariablesValid = !this.cardVariablesForm ||
                this.cardVariablesForm.every(cardArr => Array.isArray(cardArr)
                    ? cardArr.every(val => val !== '' && val !== undefined)
                    : true);
            const cardButtonVariablesValid = !this.cardButtonVariablesForm ||
                this.cardButtonVariablesForm.every(cardArr => Array.isArray(cardArr)
                    ? cardArr.every(val => val !== '' && val !== undefined)
                    : true);
            this.isValidForm =
                variablesValid && headerVariablesValid && buttonVariablesValid && cardVariablesValid && cardButtonVariablesValid;
            return this.isValidForm;
        };
        this.modal = modal;
        this.MessageTemplateUtil = MessageTemplateUtil;
        this.ModalService = ModalService;
        this.initialize();
    }
    initialize() {
        this.getVariables();
        this.getHeaderVariables();
        this.bodyOriginal = this.modal.body;
        this.headerOriginal = this.modal.headerText || '';
        this.getButtonsVariables();
        if (this.modal.footer && !this.modal.footerText) {
            this.modal.footerText = this.modal.footer;
        }
        this.updatePaymentCardWithOriginalText();
        this.updateCardVariablesOriginalText();
        this.ensureFooterUpdate();
    }
    updatePaymentCardWithOriginalText() {
        if (this.modal.type === 'payment') {
            setTimeout(() => {
                try {
                    const paymentCardBody = document.querySelector('message-template-payment-card .amtc__description');
                    if (paymentCardBody && this.modal.body) {
                        paymentCardBody.innerHTML = this.modal.body;
                    }
                    const paymentCardHeader = document.querySelector('message-template-payment-card .amtc__header');
                    if (paymentCardHeader && this.modal.headerText) {
                        paymentCardHeader.innerHTML = this.modal.headerText;
                    }
                    const paymentCardFooter = document.querySelector('message-template-payment-card .amtc__footer');
                    if (paymentCardFooter && this.modal.footerText) {
                        paymentCardFooter.innerHTML = this.modal.footerText;
                    }
                }
                catch (error) {
                    console.error('Error updating payment card with original text');
                }
            }, 100);
            setTimeout(() => {
                try {
                    const paymentCardFooter = document.querySelector('message-template-payment-card .amtc__footer');
                    if (paymentCardFooter && this.modal.footerText) {
                        paymentCardFooter.innerHTML = this.modal.footerText;
                    }
                }
                catch (error) {
                    console.error('Error updating payment card footer');
                }
            }, 500);
        }
    }
    updateCardVariablesOriginalText() {
        if (this.modal.type === 'carousel') {
            this.modal.previewCard = this.modal.cards[0];
            if (this.modal.cards && this.modal.cards.length > 0) {
                this.cardsOriginalText = this.modal.cards.map(card => card.text || '');
            }
        }
    }
    setCardVariable(cardIndex, variableIndex, value) {
        if (!this.cardVariablesForm) {
            this.cardVariablesForm = [];
        }
        if (!this.cardVariablesForm[cardIndex]) {
            this.cardVariablesForm[cardIndex] = [];
        }
        this.cardVariablesForm[cardIndex][variableIndex] = value;
    }
    setCardButtonVariable(cardIndex, buttonIndex, variableIndex, value) {
        if (!this.cardButtonVariablesForm) {
            this.cardButtonVariablesForm = [];
        }
        if (!this.cardButtonVariablesForm[cardIndex]) {
            this.cardButtonVariablesForm[cardIndex] = [];
        }
        if (!this.cardButtonVariablesForm[cardIndex][buttonIndex]) {
            this.cardButtonVariablesForm[cardIndex][buttonIndex] = [];
        }
        this.cardButtonVariablesForm[cardIndex][buttonIndex][variableIndex] = value;
    }
    updateCard(cardIndex) {
        const originalCard = this.modal.cards[cardIndex];
        if (!originalCard)
            return;
        const originalText = this.cardsOriginalText[cardIndex] || originalCard.text || '';
        let cardTextChange = originalText;
        if (this.cardVariablesForm[cardIndex]) {
            this.cardVariablesForm[cardIndex].forEach((value, index) => {
                const variable = `{{${index + 1}}}`;
                if (value !== '' && value !== variable) {
                    cardTextChange = cardTextChange.replace(variable, value);
                }
            });
        }
        const formattedText = this.MessageTemplateUtil.formatMessageToPreviewView(cardTextChange);
        this.modal.previewCard = {
            ...originalCard,
            text: formattedText,
        };
    }
    submit() {
        if (this.isValid()) {
            this.ModalService.closeModals();
            // Reconstrói a estrutura original de cardButtonVariables
            const reconstructedButtonVars = this.reconstructCardButtonVariables();
            return this.modal.onConfirm(this.variablesForm, this.variablesButtonsForm, this.headerVariablesForm, this.cardVariablesForm, reconstructedButtonVars);
        }
    }
    reconstructCardButtonVariables() {
        if (!this.modal.cardButtonVariables || !this.cardButtonVariablesForm) {
            return [];
        }
        return this.cardButtonVariablesForm.map(cardButtons => {
            if (!cardButtons)
                return [];
            return cardButtons.map(buttonVars => {
                if (!buttonVars)
                    return [];
                return buttonVars.filter(val => val !== undefined && val !== '');
            });
        });
    }
    updateBody() {
        let bodyChange = this.bodyOriginal;
        for (let i = 0; i < this.variables.length; i++) {
            if (this.variables[i].value !== '' &&
                this.variables[i].value !== this.variables[i].variable) {
                bodyChange = bodyChange.replace(this.variables[i].variable, this.variables[i].value);
            }
        }
        this.modal.body = this.MessageTemplateUtil.formatMessageToPreviewView(bodyChange);
        this.updatePaymentCardBodyIfNeeded();
    }
    updatePaymentCardBodyIfNeeded() {
        if (this.modal.type === 'payment') {
            try {
                const paymentCardBody = document.querySelector('message-template-payment-card .amtc__description');
                if (paymentCardBody) {
                    paymentCardBody.innerHTML = this.modal.body;
                }
            }
            catch (error) {
                console.error('Error updating payment card body');
            }
        }
    }
    updateHeader() {
        let headerChange = this.headerOriginal;
        for (let i = 0; i < this.headerVariables.length; i++) {
            if (this.headerVariables[i].value !== '' &&
                this.headerVariables[i].value !==
                    this.headerVariables[i].variable) {
                headerChange = headerChange.replace(this.headerVariables[i].variable, this.headerVariables[i].value);
            }
        }
        this.modal.headerText = this.MessageTemplateUtil.formatMessageToPreviewView(headerChange);
        this.updatePaymentCardIfNeeded();
    }
    updatePaymentCardIfNeeded() {
        if (this.modal.type === 'payment') {
            try {
                const paymentCardHeader = document.querySelector('message-template-payment-card .amtc__header');
                if (paymentCardHeader) {
                    paymentCardHeader.innerHTML = this.modal.headerText;
                }
                const paymentCardFooter = document.querySelector('message-template-payment-card .amtc__footer');
                if (paymentCardFooter && this.modal.footerText) {
                    paymentCardFooter.innerHTML = this.modal.footerText;
                }
            }
            catch (error) {
                console.error('Error updating payment card header/footer');
            }
        }
    }
    setVariable(variable, value) {
        const index = this.variables.indexOf(variable);
        variable.value = value;
        this.variables.splice(index, 1);
        this.variables.splice(index, 0, variable);
        this.variablesForm[index] = value;
        return variable;
    }
    setHeaderVariable(variable, value) {
        const index = this.headerVariables.indexOf(variable);
        variable.value = value;
        this.headerVariables.splice(index, 1);
        this.headerVariables.splice(index, 0, variable);
        this.headerVariablesForm[index] = value;
        return variable;
    }
    setButtonVariable(buttonIndex, variableIndex, value) {
        if (this.buttonsVariables[buttonIndex]) {
            this.buttonsVariables[buttonIndex].values[variableIndex] = value;
            this.variablesButtonsForm[buttonIndex].values[variableIndex] = value;
        }
    }
    getVariables() {
        this.modal.variables?.forEach(variable => {
            const index = this.modal.body.indexOf(variable);
            this.variables.push({
                variable: variable,
                position: index,
                value: variable,
            });
            this.variablesForm.push('');
        });
    }
    getHeaderVariables() {
        this.modal.headerVariables?.forEach(variable => {
            const index = this.modal.headerText
                ? this.modal.headerText.indexOf(variable)
                : -1;
            this.headerVariables.push({
                variable: variable,
                position: index,
                value: variable,
            });
            this.headerVariablesForm.push('');
        });
    }
    getButtonsVariables() {
        if (this.modal.buttonsVariables &&
            this.modal.buttonsVariables.length > 0) {
            this.buttonsVariables = this.modal.buttonsVariables.map((buttonVar) => ({
                buttonIndex: buttonVar.buttonIndex,
                buttonText: buttonVar.buttonText,
                url: buttonVar.url,
                variables: buttonVar.variables,
                values: buttonVar.variables.map(() => ''),
            }));
            this.variablesButtonsForm = this.buttonsVariables.map(button => ({
                buttonIndex: button.buttonIndex,
                buttonText: button.buttonText,
                url: button.url,
                variables: button.variables,
                values: [...button.values],
            }));
        }
        else {
            this.modal.buttons.forEach((button, buttonIndex) => {
                const buttonsVariableMatch = this.modal.matchVariables(button.url);
                if (buttonsVariableMatch?.length > 0 &&
                    button.type == CallToActionTypes.URL.toUpperCase()) {
                    this.buttonsVariables.push({
                        buttonIndex: buttonIndex,
                        buttonText: button.text,
                        url: button.url,
                        variables: buttonsVariableMatch,
                        values: buttonsVariableMatch.map(() => ''),
                    });
                    this.variablesButtonsForm.push({
                        buttonIndex: buttonIndex,
                        buttonText: button.text,
                        url: button.url,
                        variables: buttonsVariableMatch,
                        values: buttonsVariableMatch.map(() => ''),
                    });
                }
            });
        }
    }
    parseButtonVariableId(id) {
        const match = id.match(/button-(\d+)-var-(\d+)/);
        if (match) {
            return {
                buttonIndex: parseInt(match[1], 10),
                variableIndex: parseInt(match[2], 10),
            };
        }
        return { buttonIndex: null, variableIndex: null };
    }
    getVariable(id) {
        return this.variables.find(element => element.variable === id);
    }
    getHeaderVariable(id) {
        return this.headerVariables.find(element => element.variable === id);
    }
    getButtonVariableLabel(buttonIndex, variableIndex) {
        if (this.buttonsVariables[buttonIndex]) {
            const button = this.buttonsVariables[buttonIndex];
            return `${button.buttonText} - ${button.variables[variableIndex]}`;
        }
        return '';
    }
    ensureFooterUpdate() {
        if (this.modal &&
            this.modal.type === 'payment' &&
            this.modal.footerText) {
            const updateFooter = () => {
                const paymentCardFooter = document.querySelector('message-template-payment-card .amtc__footer');
                if (paymentCardFooter && this.modal && this.modal.footerText) {
                    paymentCardFooter.innerHTML = this.modal.footerText;
                    return true;
                }
                return false;
            };
            if (!updateFooter()) {
                setTimeout(() => updateFooter(), 500);
            }
        }
    }
}
MessageTemplateSampleModalController.$inject = ['modal', 'MessageTemplateUtil', 'ModalService'];
